export const NAME_REGEXP = /^[a-zA-Z0-9\s_.-]+$/;

export const routes = [
    {name: 'Magnet', route: '/sales', permissionKey: "/", icon: 'magnet-icon', isHasChildren: true, healthName: ["Magnet for Sales", "Magnet for Vendors"],
        routes: [
            {name: 'Sales', route: '/sales', permissionKey: "/sales", healthName: "Magnet for Sales"},
            {name: 'Vendors', route: '/vendors', permissionKey: "/vendors", healthName: "Magnet for Vendors"},
        ]
    },
]
